<template>
  <div>
    <b-navbar toggleable="lg">
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-navbar toggleable>
        <b-navbar-brand>
          <div class="logo">
            <img src="../assets/logo1.png" />
          </div>
          <div class="goback" @click="goBack" v-if="showEditorComponent">
            Back
          </div>
        </b-navbar-brand>
      </b-navbar>

      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-navbar-nav>
            <b-nav-item>
              <span class="nav-links" @click="allnotification"
                >All notifications</span
              >
            </b-nav-item>
             <b-nav-item>
              <span class="nav-links" @click="healthCheck"
                >API Health Check</span
              >
            </b-nav-item>
            <b-nav-item>
              <span class="nav-links" href="javascript:void(0)" @click="Logout"
                >Sign out</span
              >
            </b-nav-item>
          </b-navbar-nav>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <b-container class="login-container">
      <div>
        <h5 v-if="isEditWidgetHeading">Select which widget to edit below</h5>
        <div v-if="!showEditorComponent">
          <b-form-select
            v-model="selectedId"
            value-field="ContentID"
            text-field="Widget"
            :options="options"
            class="mb-3"
          >
            <!-- This slot appears above the options from 'options' prop -->
            <template v-slot:first>
              <b-form-select-option :value="null" disabled
                >-- Please select an option --</b-form-select-option
              >
            </template>
          </b-form-select>
          <button v-on:click="editSelectedWidget">Edit selected widget</button>
        </div>
        <Editor
          v-if="showEditorComponent"
          :selected="selectedId"
          :selectedObj="selectedObj"
        />
      </div>
    </b-container>

    <img alt="footer" width="100%" src="../assets/footer.png" />
    <v-idle @idle="onidle" :loop="true" :wait="5" :duration="IDLETIMEOUT" />
  </div>
</template>
<script>
import Editor from "./../components/Editor";
import HealthCheck from "./../views/HealthCheck";
import Allnotification from "./../views/Allnotification";
import LogoSvg from "../assets/logo.svg";
import router from "./../router";
import { HTTP } from "./../helpers/http-common";
import { APIURLS } from "./../helpers/apiUrls";
import { IDLETIMEOUT } from "../helpers/constants";

export default {
  name: "Admin",
  components: {
    Editor,
    LogoSvg,
    HealthCheck,
    Allnotification
  },
  data() {
    return {
      showEditorComponent: false,
      selectedId: null,
      selectedObj: [],
      options: [],
      isEditWidgetHeading: true,
      lr_display: "none",
      IDLETIMEOUT: IDLETIMEOUT,
    };
  },
  methods: {
    getContentWidget() {
      HTTP.get(`${APIURLS.getContentWidget}`)

        .then((response) => {
          this.options = response.data;
        })
        .catch((error) => {
          alert(error.response.data.Message);
        });
    },
    editSelectedWidget() {
      if (this.selectedId) {
        this.selectedObj = this.options.filter(
          (option) => option.ContentID == this.selectedId
        );
        this.showEditorComponent = true;
        this.isEditWidgetHeading = false;
      } else {
        alert("Please select the widget to continue");
      }
    },
    goBack() {
      this.showEditorComponent = false;
      this.selectedId = null;
      this.getContentWidget();
      // this.options = response.data;
    },
    Logout() {
      this.$store.dispatch("login/logout");
    },
    healthCheck() {
      router.push("/healthcheck");
    },
     allnotification() {
      router.push("/allnotification");
    },
    onidle() {
      this.$store.dispatch("login/logout");
    },
  },
  mounted() {
    this.getContentWidget();
    this.$store.dispatch("login/refreshToken");
  },
  created() {},
};
</script>
<style scoped lang="scss">
.goback {
  font-size: 25px;
  cursor: pointer;
}
.goback:hover {
  text-decoration: underline;
}
.login-container {
  background: #fff;
  border: 1px solid #fff;
  border-radius: 14px;
  background-color: white;
  // box-shadow: 0px 3px 5px 3px #aaaaaa;
  // padding: 51px;
}
.logo {
  img {
    width: 40%;
  }
}
.v-idle {
  display: none;
}
</style>